// /components/StatusWidget.js
import { useEffect, useState } from 'react';

export default function StatusWidget() {
  const [status, setStatus] = useState({
    firestore: 'checking',
    stripe: 'checking',
    alpaca: 'checking',
    openai: 'checking'
  });

  useEffect(() => {
    // This function checks the status of all your services in parallel.
    async function checkAll() {
      const services = ['firestore', 'stripe', 'alpaca', 'openai'];
      const promises = services.map(service => 
        fetch(`/api/health/${service}`).then(res => res.json())
      );
      
      try {
        const results = await Promise.all(promises);
        const newStatus = {};
        results.forEach(result => {
          // This line now works correctly because the backend provides `result.service`
          newStatus[result.service.toLowerCase()] = result.ok ? 'ok' : 'fail';
        });
        setStatus(newStatus);
      } catch (error) {
        // If any check fails, mark all as failed for safety.
        console.error("Health check fetch failed:", error);
        setStatus({ firestore: 'fail', stripe: 'fail', alpaca: 'fail', openai: 'fail' });
      }
    }
    
    checkAll();
    // Re-check every 2 minutes
    const interval = setInterval(checkAll, 120000); 
    return () => clearInterval(interval);
  }, []);

  // A small component to render the colored status dot.
  const StatusIcon = ({ status }) => {
    const color = status === 'ok' ? 'bg-green-500' : status === 'checking' ? 'bg-yellow-500' : 'bg-red-500';
    return <span className={`inline-block w-3 h-3 rounded-full ${color}`}></span>;
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200">
      <h3 className="font-bold text-lg mb-3 text-gray-800">System Status</h3>
      <div className="space-y-2 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Firestore:</span>
          <StatusIcon status={status.firestore} />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Stripe:</span>
          <StatusIcon status={status.stripe} />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Alpaca:</span>
          <StatusIcon status={status.alpaca} />
        </div>
        <div className="flex items-center justify-between">
          <span className="text-gray-600">OpenAI:</span>
          <StatusIcon status={status.openai} />
        </div>
      </div>
    </div>
  );
}
